// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"575b21dc","95":"8501421c","285":"fc04e4e5","522":"4a239228","538":"80cfceb4","603":"2fbd6d93","633":"88dbb6a1","636":"69edcadd","731":"9a39f735","885":"584837c0","955":"9c685c28","962":"5d8aa217"}[chunkId] + ".chunk.js";
};